import React, { useEffect } from "react";
import styled from "styled-components";

import { tokens } from '../../public/tokens.js';
const {
  colors,
  typography,
  globals,
  effects,
  ui
} = tokens;

/**
 * Full-screen overlay backdrop for dialog
 * Blocks background interaction and centers dialog content
 */
const DialogOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 999;
  backdrop-filter: ${effects.effects["backdrop-blur-12"]};
  -webkit-backdrop-filter: ${effects.effects["backdrop-blur-12"]};
  background : color-mix(in srgb, ${colors.neutral.black} 55%, transparent);
`;

/**
 * Container for dialog content
 * Handles sizing, background, and layout structure
 */
const DialogContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 900px;

  border-radius: ${globals["border-radius"]};
  background: ${colors.neutral.black}
  overflow: hidden;

  box-shadow: ${effects.effects.shadow.default};
`;


/**
 * Dialog component for rendering modal content with overlay support
 *
 * @param {Object} props
 * @param {boolean} props.open - Controls visibility of dialog
 * @param {Function} props.onOpenChange - Callback to close/open dialog
 * @param {React.ReactNode} props.children - Dialog content
 * @returns {JSX.Element | null}
 */
const Dialog = ({ open, onOpenChange, children }) => {
  useEffect(() => {
    /**
     * Handles ESC key press to close dialog
     *
     * @param {KeyboardEvent} event
     */
    const handleEscKeyPress = (event) => {
      if (event.key === "Escape") {
        onOpenChange();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscKeyPress);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKeyPress);
    };
  }, [open, onOpenChange]);

  if (!open) return null;

  return (
    <DialogOverlay onClick={onOpenChange}>
      <DialogContent onClick={(event) => event.stopPropagation()}>
        {children}
      </DialogContent>
    </DialogOverlay>
  );
};

export default Dialog;